<div class="container-fluid">
    <div class="col-8 offset-2">
        <table mat-table [dataSource]="profiles" class="mat-elevation-z8">
            <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
                <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                <ng-container *ngIf="column !== 'action'; else ELSE_BLOC">
                    <td mat-cell *matCellDef="let element"> {{ element.user[column] }} </td>
                </ng-container>
                <ng-template #ELSE_BLOC>
                    <td *matCellDef="let element;" mat-cell>
                        <div *ngIf="!isProfilActif(element)">
                        <div class="d-flex justify-content-center">
                            <button (click)="connect(element)" type="button" class="btn btn-outline-primary">
                             Choisir
                            </button>
                        </div>
                    </div>
                    </td>
                </ng-template>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
